import type { ThemeData } from '../models';
import { defaultTheme } from './defaultTheme';

export const toothWipesTheme: ThemeData = {
  ...defaultTheme,
};
